import type { DraftEntry } from './state/loggerDraftTypes';

// THE rule for "completing this set raises the AMRAP question" — one function,
// because two callers need the same answer and a guard that disagrees with the
// prompt it guards is worse than no guard at all:
//
//   1. useAmrapConfirm.shouldPrompt — decides whether to ask.
//   2. useSetCyclePill — decides whether the bodyweight nudge must stand down
//      and wait its turn (LG-27, decided 2026-08-12: the AMRAP question wins
//      the tap, because it is about a measurement that evaporates when the
//      athlete moves on, while a missing profile weight will still be missing
//      later).
//
// Extracted rather than duplicated: the two live one call apart on the same
// gesture, so a drift between them would surface as either two modals stacked
// on one tap (the bug) or a nudge suppressed by a question that never came (a
// silently swallowed prompt, which is worse — nothing on screen says so).
//
// Cardio and timed sets have no AMRAP chip (FocusPanelChipRow) and no `amrap`
// field on the payload, so a prompt there would ask for something unwritable.
// The reps-open form of the test is the only one built.
// `readonly` because this only reads: it accepts both callers' shapes
// (useSetCyclePill holds a readonly array, useAmrapConfirm a mutable one).
export const willPromptAmrap = (
  entries: readonly DraftEntry[],
  entryIdx: number,
  setIdx: number,
): boolean => {
  const entry = entries[entryIdx];
  if (!entry) return false;
  if (entry.isCardio || entry.isTimeBased) return false;
  const set = entry.sets[setIdx];
  if (!set) return false;
  return set.amrapPrescribed === true && set.amrap !== true;
};
